/* tslint:disable */
/* eslint-disable */

/**
 * 1 = MatiereAPointer
 * 2 = MatiereAQuota
 * 3 = MatiereARetrait
 */
export enum TypeDechetValues {
  MatiereAPointer = 1,
  MatiereAQuota = 2,
  MatiereARetrait = 3
}
